/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';
import config from 'js-sdk/src/jrs.configs';
import Highcharts from './HighchartsLoader';
import i18n from '../../../../i18n/all.properties';
import moment from 'moment';

// in the next block we have a non-standard structure: i18n with hard-coded language
// It's done because of chart exporting tool, which uses this file and it doesn't have access to i18n
// So by this we can be sure no label will be defected
const i18nMonths = [
    i18n["months.label.january"] || "January",
    i18n["months.label.february"] || "February",
    i18n["months.label.march"] || "March",
    i18n["months.label.april"] || "April",
    i18n["months.label.may"] || "May",
    i18n["months.label.june"] || "June",
    i18n["months.label.july"] || "July",
    i18n["months.label.august"] || "August",
    i18n["months.label.september"] || "September",
    i18n["months.label.october"] || "October",
    i18n["months.label.november"] || "November",
    i18n["months.label.december"] || "December"
];
const i18nWeekdays = [
    i18n["week.days.label.sunday"] || "Sunday",
    i18n["week.days.label.monday"] || "Monday",
    i18n["week.days.label.tuesday"] || "Tuesday",
    i18n["week.days.label.wednesday"] || "Wednesday",
    i18n["week.days.label.thursday"] || "Thursday",
    i18n["week.days.label.friday"] || "Friday",
    i18n["week.days.label.saturday"] || "Saturday"
];

const shortMonths = function getMonths() {
    return _.map(["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"], function (month) {
        return _.capitalize(moment("1970-".concat(month, "-01"))
            .locale(config.userLocale)
            .format("MMMM")).slice(0, 3);
    });
};

Highcharts.setOptions({
    lang: {
        contextButtonTitle: i18n["highcharts.contextButtonTitle"] || "Chart context menu",
        decimalPoint: ".",
        downloadJPEG: i18n["highcharts.downloadJPEG"] || "Download JPEG image",
        downloadPDF: i18n["highcharts.downloadPDF"] || "Download PDF document",
        downloadPNG: i18n["highcharts.downloadPNG"] || "Download PNG image",
        downloadSVG: i18n["highcharts.downloadSVG"] || "Download SVG vector image",
        invalidDate: i18n["highcharts.invalidDate"] || "",
        loading: (i18n["highcharts.loading"] || "Loading") + "...",
        months: i18nMonths,
        noData: i18n["highcharts.noData"] || "No data to display",
        printChart: i18n["highcharts.printChart"] || "Print chart",
        resetZoom: i18n["highcharts.resetZoom"] || "Reset zoom",
        resetZoomTitle: i18n["highcharts.resetZoomTitle"] || "Reset zoom level 1:1",
        shortMonths: shortMonths(),
        thousandsSep: ",",
        weekdays: i18nWeekdays
    }
});

export default Highcharts;
